import { StyleSheet, css } from "aphrodite/no-important";
import { getCategoryColor } from "./utils";

const Sidebar = ({ categories, isOpen, categoryStatus, setCategoryStatus }) => {
  const handleClick = (category) => {
    const newCategoryStatus = { ...categoryStatus };
    newCategoryStatus[category] = !categoryStatus[category];
    setCategoryStatus(newCategoryStatus);
  };
  return (
    <div
      className={css(isOpen ? styles.sideBar : [styles.sideBar, styles.hidden])}
    >
      {categories.map((category, i) => {
        const isVisible = categoryStatus[category];
        const color = isVisible ? getCategoryColor(i) : "#999";
        return (
          <div
            className={css(
              isVisible ? styles.category : [styles.category, styles.inactive]
            )}
            key={category}
            onClick={() => handleClick(category)}
          >
            <div
              className={css(styles.color)}
              style={{ background: color }}
            ></div>
            {category}
          </div>
        );
      })}
      <a
        className={css(styles.submitLink)}
        href="https://airtable.com/appRMPdQFN2xPyWe0/pagIpT9ZFBgbXIOKU/form"
        target="blank"
      >
        <svg
          className={css(styles.plusIcon)}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
        </svg>
        Add event
      </a>
    </div>
  );
};

const styles = StyleSheet.create({
  sideBar: {
    width: "250px",
    background: "white",
    minHeight: "calc(100vh - 25px)",
    position: "fixed",
    top: "47px",
    zIndex: "5",
    padding: "30px",
    boxShadow: "rgba(17, 12, 46, 0.15) 0px 68px 100px 0px;",
  },
  hidden: {
    display: "none",
  },
  sideBarInner: {
    position: "relative",
  },
  category: {
    padding: "4px 0px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
    fontSize: "14px",
  },
  inactive: {
    color: "#999",
  },
  color: {
    height: "10px",
    width: "10px",
    marginRight: "6px",
    borderRadius: "100%",
  },
  submitLink: {
    position: "absolute",
    bottom: "100px",
    right: "20px",
    background: "rgb(143 161 186)",
    color: "white",
    fontSize: "12px",
    padding: "6px 12px 6px 10px",
    borderRadius: "7px",
    cursor: "pointer",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    transition: "background 500ms",
    width: "max-content",
    ":hover": {
      background: "rgb(117 135 161)",
    },
  },
  plusIcon: {
    height: "12px",
    marginRight: "3px",
    fill: "white",
  },
});

export default Sidebar;
